module.exports = __webpack_public_path__ + "img/pre_img.237be285.svg";